import { Typography, Button, Alert } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const AlertsCards = ({
  id,
  initialValues,
  addData,
  updateData,
  singleData,
}) => {
  return (
    <div className="w-full block">
      <Typography variant="subtitle1">
        {id < 1 && <span>Ürün Ekle</span>}
        {id > 0 && <span>{initialValues.title} Ürününü Düzenle</span>}
      </Typography>
      {addData.data && (
        <div
          className={`w-full flex items-center justify-between ${
            addData.data?.status === "success" ? "bg-[#edf7ed]" : "bg-[#fdeded]"
          } `}
        >
          <Alert sx={{ width: "70%" }} severity={addData.data?.status}>
            {addData.data?.message}
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href={`/get-products/${id}`}
          >
            Geri Dön
          </Button>
        </div>
      )}
      {addData.isError && (
        <div className="w-full flex items-center justify-between bg-[#fdeded]">
          <Alert severity="error">
            Ürün Ekleme Sırasında Bir Hata oluşu. Lütfen Tekrar Deneyiniz!
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href={`/get-products/${id}`}
          >
            Geri Dön
          </Button>
        </div>
      )}
      {updateData.isSuccess && (
        <div className="w-full flex items-center justify-between bg-[#edf7ed]">
          <Alert severity="success">
            {initialValues.title} Ürünü Başarıyla Güncellendi ...
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href={`/get-products/${singleData.data?.parentCategory?.id}`}
          >
            Geri Dön
          </Button>
        </div>
      )}
      {updateData.isError && (
        <div className="w-full flex items-center justify-between bg-[#fdeded]">
          <Alert severity="error">
            {initialValues.title} Ürünü Güncellenirken Bir Hata Oluştu!
          </Alert>
          <Button
            variant="contained"
            color="info"
            size="small"
            startIcon={<ArrowBack />}
            href={`/get-products/${singleData.data?.parentCategory?.id}`}
          >
            Geri Dön
          </Button>
        </div>
      )}
    </div>
  );
};

export default AlertsCards;
